import { useMemo } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { startOfDay, parseISO, isValid, formatISO } from "date-fns";

// Stores date as ISO string at start of day (local)
const SurveyEntry_Date = ({ value, onChange, isDisabled }) => {
  const dateValue = useMemo(() => {
    if (!value) return null;
    try {
      const parsed =
        typeof value === "string" ? parseISO(value) : new Date(value);
      return isValid(parsed) ? parsed : null;
    } catch {
      return null;
    }
  }, [value]);

  const handleChange = (newDate) => {
    if (!newDate || !isValid(newDate)) {
      onChange(null);
      return;
    }
    const iso = formatISO(startOfDay(newDate));
    onChange(iso);
  };

  return (
    <DatePicker
      slotProps={{ textField: { size: "small", fullWidth: true } }}
      value={dateValue}
      onChange={handleChange}
      disabled={isDisabled}
    />
  );
};

export default SurveyEntry_Date;
